import * as React from 'react';
import { cn } from '../../lib/utils';
import { placeholderStyles } from './typography';

/**
 * Standardized Input Component
 * Consistent styling across admin and user flows
 * Supports light and dark themes
 */
export const Input = React.forwardRef(function Input({ className, type, ...props }, ref) {
  return (
    <input
      type={type}
      className={cn(
        'flex h-10 w-full rounded-md border border-gray-300 dark:border-gray-600',
        'bg-white dark:bg-gray-800',
        'px-3 py-2 text-sm font-normal font-sans',
        'text-gray-900 dark:text-gray-100',
        placeholderStyles,
        'ring-offset-background',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'transition-colors',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export default Input;
